import { UserProfile } from './registration';
import { Experience } from './experience';
import { Systemuser } from './systemuser';


export class UserConnection {
    Id:number;
    UserId:number;
    ConnectedToUserId:number;
    StatusId:number;
    InvitationGuid:string;
    InvitedOn:Date;
    ConnectedOn:Date;
    IsActive:boolean;
    UserProfile:UserProfile;
    CurrentJob:Experience;
    Active:string;
    SystemUser:Systemuser;
    UserDefaultAddress:string;
    TotalMessagesNotification:number;
    NotificationTime:Date;
    HasChatHistory:boolean;
    CanUserSendMessage:boolean;
    IsRemoveChat:boolean;
    Isblocked:boolean;
}